/**
 * URL du Launcher lue au runtime (évite l’inlining de `environment` en build prod).
 * Mis à jour par load-runtime-config (provideAppInitializer) et synchronisé avec environment.
 */
let launcherUrl = '';

export function setLauncherUrlFromEnv(env: { otherAppUrl?: string }): void {
  const v = env.otherAppUrl?.trim();
  if (v) {
    launcherUrl = v;
  }
}

export function getLauncherUrl(): string {
  return launcherUrl;
}
